import { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import LoginPopup from "../popupPages/LoginPopup";
import RegisterPopup from "../popupPages/RegisterPopup";
import GoogleLoginButton from "./GoogleLoginButton";
import DeleteAccountPopup from "../popupPages/DeleteAccountPopup";
import { useLanguage, Language } from "../context/LanguageContext";
import { getUserToken } from "../utils/tokenUtils";

interface MainHamburgerMenuProps {
  isSuperUser: boolean;
  fncLogout: () => void;
  isLoggedIn: boolean;
  onLoginSuccess: () => void;
}

function MainHamburgerMenu({ isSuperUser, fncLogout, isLoggedIn, onLoginSuccess }: MainHamburgerMenuProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  const closeMenu = () => closeRef.current?.click();
  const { t, lang, setLang } = useLanguage();

  useEffect(() => {
    const handleSessionExpired = () => {
      // Offcanvas menüyü kapat
      closeRef.current?.click();
      // Misafir + henüz şehir seçmemiş kullanıcıda Dashboard "Konumunuzu Seçin" popup'ını
      // zaten açacak; ikisi üst üste binmesin diye bu durumda login modal'ı açma.
      if (!getUserToken() && !localStorage.getItem("guestTownId")) return;
      // Login modalını aç
      const loginEl = document.getElementById("loginModal");
      if (loginEl) {
        // @ts-ignore
        const bsModal = window.bootstrap?.Modal?.getOrCreateInstance(loginEl);
        bsModal?.show();
      }
    };
    window.addEventListener("session-expired", handleSessionExpired);
    return () => window.removeEventListener("session-expired", handleSessionExpired);
  }, []);

  return (
    <>
    <div
      className="offcanvas offcanvas-start"
      id="offcanvasNavbar"
      aria-labelledby="offcanvasNavbarLabel"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
          {t("menu.title")}
        </h5>
        <button
          ref={closeRef}
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label={t("common.close")}
        ></button>
      </div>
      <div className="offcanvas-body">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
          <li className="nav-item">
            <NavLink className="nav-link" to="/" onClick={closeMenu}>
              {t("menu.home")}
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/restaurants" onClick={closeMenu}>
              {t("menu.allPlaces")}
            </NavLink>
          </li>
          {isLoggedIn && (
            <>
              <li className="nav-item">
                <NavLink className="nav-link" to="/profil" onClick={closeMenu}>
                  {t("menu.myProfile")}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/adreslerim" onClick={closeMenu}>
                  {t("menu.myAddresses")}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/orderhistory" onClick={closeMenu}>
                  {t("menu.myOrders")}
                </NavLink>
              </li>
            </>
          )}
        </ul>

        {/* Dil Seçici */}
        <div className="d-flex align-items-center gap-2 mt-3 mb-2">
          <small className="text-muted">{t("menu.language")}:</small>
          {(["tr", "en"] as Language[]).map((l) => (
            <button
              key={l}
              className={`btn btn-sm rounded-pill px-3 ${lang === l ? "btn-danger" : "btn-outline-secondary"}`}
              onClick={() => setLang(l)}
            >
              {l.toUpperCase()}
            </button>
          ))}
        </div>

        <div className="mt-2 d-flex flex-column gap-2">
          {isLoggedIn ? (
            <>
              <button
                type="button"
                className="btn btn-outline-danger w-100 rounded-pill"
                data-bs-dismiss="offcanvas"
                onClick={fncLogout}
              >
                <i className="bi bi-box-arrow-right me-2"></i>
                {t("menu.logout")}
              </button>
              <button
                type="button"
                className="btn btn-link btn-sm text-danger text-decoration-none w-100"
                data-bs-toggle="modal"
                data-bs-target="#deleteAccountModal"
                data-bs-dismiss="offcanvas"
              >
                <i className="bi bi-trash3 me-1"></i>
                {t("menu.deleteAccount")}
              </button>
            </>
          ) : (
            <>
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-danger flex-grow-1 rounded-pill"
                  data-bs-toggle="modal"
                  data-bs-target="#loginModal"
                  data-bs-dismiss="offcanvas"
                >
                  <i className="bi bi-box-arrow-in-right me-2"></i>
                  {t("menu.login")}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-danger flex-grow-1 rounded-pill"
                  data-bs-toggle="modal"
                  data-bs-target="#registerModal"
                  data-bs-dismiss="offcanvas"
                >
                  <i className="bi bi-person-plus me-2"></i>
                  {t("menu.register")}
                </button>
              </div>

              <div className="d-flex align-items-center gap-2 my-1">
                <hr className="flex-grow-1 m-0" />
                <span className="text-muted small">{t("common.or")}</span>
                <hr className="flex-grow-1 m-0" />
              </div>

              <GoogleLoginButton onLoginSuccess={onLoginSuccess} />
            </>
          )}
        </div>
      </div>
    </div>

    <LoginPopup onLoginSuccess={onLoginSuccess} />
    <RegisterPopup onLoginSuccess={onLoginSuccess} />
    <DeleteAccountPopup onLogout={fncLogout} />
    </>
  );
}

export default MainHamburgerMenu;
